import { useEffect, useState } from 'react';
import styles from './Venue.module.css';
import shared from './Shared.module.css';
import { EventModel } from '../models/EventModel';
import EventItem from '../components/EventItem';
import SubscriptionSection from '../components/SubscriptionSection';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function Venue() {

    const preloaded = (window as any).__VENUE_EVENTS__ ?? [];
    console.log(preloaded);
    const [events, setEvents] = useState<EventModel[]>(preloaded || []);

    const { name } = useParams();
    const venueName = decodeURIComponent(name || "");

    useEffect(() => {
        setEvents(preloaded || []);
    }, preloaded);

    const frenchA = (venueName: string) => {
        if(venueName.toLowerCase().startsWith("le ")) {
            return "au " + venueName.substring(3);
        }
        else if(venueName.toLowerCase().startsWith("les ")) {
            return "aux " + venueName.substring(4);
        }
        else {
            return "à " + venueName;
        }
    };

    const title = `Événements ${frenchA(venueName)} (Québec) – Programmation`;
    const description = `Découvre les événements à venir ${frenchA(venueName)} : Dates, prix, billets et infos pratiques.`;

    return <div style={{position: 'relative'}}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={location.href} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
        <SubscriptionSection stickyBanner={true}/>
        <h1>Calendrier des événements et activités à venir</h1>
        <h2>{venueName}</h2>
        <div className={styles.eventsContainer}>
            {events.length == 0 && <div className={styles.emptyState}>
                <p>Il n'y a aucun événement ou activité à venir pour l'instant. </p>
                </div>}
            {events.map(e => 
                <EventItem event={e} />
            )}
        </div>

        <div style={{display:"flex", justifyContent: "center", gap: "20px", flexDirection: "column"}}>
            <Link to="/ville-quebec/aujourdhui" reloadDocument className={shared.ctaBtn}>Voir quoi faire à Québec aujourd'hui</Link>
            <Link to="/ville-quebec/evenements-cette-semaine" reloadDocument className={shared.ctaBtn}>Voir tous les événements de cette semaine</Link>
            <Link to="/#search" className={shared.ctaBtn}>Rechercher parmi tous les événements</Link>
        </div>
        <SubscriptionSection />
    </div>;

}
